import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-marinepaymentinvoice',
  templateUrl: './marinepaymentinvoice.component.html',
  styleUrls: ['./marinepaymentinvoice.component.scss']
})
export class MarinepaymentinvoiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
